import { forEach } from "lodash";

var mode = "stage";

var search = window.location.search;
var localStorageValidPeriod = 14; //days

var utms = [
    'utm_source',
    'utm_medium',
    'utm_campaign'
];

if(isQueryStringPresent(search)){
    let GET = [];
    
    GET = parseQueryString(search);

    Object.entries(GET).forEach(( [key,value] ) => {
        _console(key,"key");
        _console(value,"value");
        _console(key + "," +value, "pair");
        stashToLocalStorage(key, value);
    })
}

if(validateLocateStorageTimestamp()){
    addHiddenFormFields();
}

function addHiddenFormFields(){
    let forms = document.querySelectorAll("form");
    forms.forEach(function(form){

        utms.forEach(function(utm){
            _console(utm, "utm");
            let field = form.querySelector('[name="' + utm + '"]');
            field.setAttribute("value", getLocalStorageValue(utm));
        })
    });
}

function getLocalStorageValue(key){
    let value = localStorage.getItem(key);
    if(value){
        return value;
    }

    return '';
}

function stashToLocalStorage(key, value){
    updateLocalStorageTimestamp();
    localStorage.setItem(key, value);
}

function validateLocateStorageTimestamp(){
    let now = Date.now();
    let then = localStorage.getItem("rebel-utm-timestamp");

    if(now && then){
        let diff = now - then;
        diff = diff / (1000 * 60 * 60 * 24);
        if(diff >= localStorageValidPeriod){
            return false;
        }
    }

    return true;
}

function updateLocalStorageTimestamp(){
    localStorage.setItem('rebel-utm-timestamp', Date.now());
}

function parseQueryString(search){
    let query_params = [];
    let temp = [];

    search = search.replace("?",""); //trim
    query_params = search.split("&"); //seperate params
   
    forEach(query_params, function(param){
        let parts = [];
        parts = param.split("="); //seperate key => value
        temp[parts[0]] = parts[1];
    });

    return temp;
}

function isQueryStringPresent(){ 
    return (search) ? true : false;
}

function _console(value, text){
    if(mode === 'dev'){
        console.log(value,text);
    }
}